import React, {Component} from 'react';
import {SumText, Summary, SumHeader} from '../styles/app_styles.js';

import BlankSumContainer from '../components/blank_summary_panel.js'


export default class SummaryPanel extends Component {
  constructor(props){
    super(props)
    this.state = {
      text: props.summary.text,
      color_arr: props.summary.colors,
      highlights: props.summary.highlights
    }
  }

  eval_color(regex, tag_arr){
    var assign_tag
    tag_arr.forEach((tag, ndx) => {
      if(tag.regex === regex) assign_tag = tag_arr[ndx].color
    })
    return assign_tag
  }

  highlight(summary, regexes, tag_arr) {
    if (!regexes.length) {
       return summary;
    }
    //use timestamp to create unique key
    var date = new Date();
    var keytime = date.getTime();

    let split = summary.split(regexes[0]);
    let replacements = summary.match(regexes[0]);
    let result = [];
    let color = this.eval_color(regexes[0], tag_arr)
    for (let i = 0; i < split.length - 1; i++) {
      keytime = keytime + i
      result.push(this.highlight(split[i], regexes.slice(1), tag_arr));
      result.push(<span style={ color } key={keytime}>{replacements[i]}</span>);
    }
    result.push(this.highlight(split[split.length - 1], regexes.slice(1), tag_arr));

    return result;
  }

  renderSummary(text){
    if(text){
    let highlight_terms = this.props.summary.highlights

    //regexes marks all the words to be able to add in the span.
    let regexes = highlight_terms.map(word => new RegExp(`\\b${word}\\b`, 'ig'));

    let color_arr= this.props.summary.colors
    let tag_arr = []

    color_arr.map((color, ndx) => {
      tag_arr.push({color: {color: color}, regex: regexes[ndx]})
    })

    let key = Math.floor(Math.random() * 20)
    return(
      <SumText key={key}>
        {this.highlight(text, regexes, tag_arr)}
      </SumText>
        )
      }
    }


  render(){
    let header = this.props.summary.text ? "Textual Summary" : ""
    let summary_gather = this.props.summary.text ? this.renderSummary(this.props.summary.text) : (<BlankSumContainer />)
    return(
      <Summary data-tut="summary">
        <SumHeader>
          { header }
        </SumHeader>
        { summary_gather }
      </Summary>
    )
  }
}
